import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/settings/users-img/image001.png';
import image002 from '../assetes/images/settings/users-img/image002.png';
import image003 from '../assetes/images/settings/users-img/image003.png';
import image004 from '../assetes/images/settings/users-img/image004.png';
import image005 from '../assetes/images/settings/users-img/image005.png';
import image006 from '../assetes/images/settings/users-img/image006.png';
import image007 from '../assetes/images/settings/users-img/image007.png';


export default function Users() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>
                            <Searchbar containerSelector=".search-scope" />
                            <div className='search-scope mt-4'>
                                <h1 className='mt-0 text-primary'>Users</h1>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Accessing Account Settings and filter
                                    </div>
                                    <div className="card-body">
                                        <p>  Navigating to the User Management Section : </p>
                                        <ul>
                                            <img src={image001} alt="fullview" className='img-fluid pt-10 pb-20' />
                                            <li>Go to the Settings menu on the left sidebar.</li>
                                            <li>Under the User management section, select Users (highlighted in red in the image).</li>
                                            <li>This section allows you to manage all users in your organization.</li>
                                        </ul>
                                        <p> <b> Searching for a User: </b></p>
                                        <ul>
                                            <img src={image006} alt="searchbar" className='img-fluid pt-10 pb-20' />
                                            <li>Use the Search bar at the top to find a specific user by name or email.</li>
                                            <li>The list will dynamically update as you type.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        User List Overview
                                    </div>
                                    <div className="card-body">
                                        <p>The user list displays the following columns:</p>
                                        <ul>
                                            <img src={image002} alt="table" className='img-fluid pt-10 pb-20' />
                                            <li><b>Name</b>  - Displays the user's name along with initials in a colored circle.</li>
                                            <li><b>Status</b> - Displays the active/inactive status for the user.</li>
                                            <li><b>Date Created</b> - Shows the date the user was created.</li>
                                            <li><b>Actions</b> - Provides options to edit or delete the user. <br />
                                                <img src={image003} alt="actions" className='pt-10 ' />
                                            </li>
                                        </ul>

                                        <p> <b>Editing a User</b> </p>

                                        <ul>
                                            <img src={image004} alt="Edit" className='pt-10 pb-20' />
                                            <li>Click the Edit (Pencil) icon under the Action column.
                                            </li>
                                            <li>Modify user details such as name and email.
                                            </li>
                                            <li>Click Save to apply changes.</li>
                                        </ul>

                                        <p> <b>Deleting a User</b> </p>
                                        <ul>
                                            <img src={image005} alt="Delete" className='pt-10 pb-20' />
                                            <li>Click the Delete (Trash) icon under the Action column.
                                            </li>
                                            <li>A confirmation popup will appear.
                                            </li>
                                            <li>Click Confirm to permanently remove the user.</li>
                                        </ul>

                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Adding a New User
                                    </div>
                                    <div className="card-body">

                                        <ul>
                                            <img src={image007} alt="Form" className='pt-10 pb-20' />
                                            <li>Click the + Create User button (red button on the top right).</li>
                                            <li>A form will appear where you can enter:
                                                <ul className='pt-10'>
                                                    <li> <b>Full Name</b> - Displays the user's full name.</li>
                                                    <li><b>Email Address</b> - A new user will need to set a password </li>
                                                    <li><b>Password</b> - Shows a masked password input field (●●●●●). Clicking the "X" button might clear the password field.</li>

                                                    <li>Click Save to create the user.
                                                        <ul className='pt-10'>
                                                            <li><b>Cancel</b> - Closes the modal without saving changes.</li>
                                                            <li><b>Save</b> - Saves the updated user details.</li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
